<template>
  <section class="section is-marginless">
    <div class="columns is-centered">
      <div class="column is-half">
        <h3 class="title">Thank you for onboarding!</h3>
        <br />
        <h3 class="subtitle">
          Everything should be good to go!
          <br />
          <br />
          <button class="button is-primary is-outlined" href="" @click="reset">Ok</button>
        </h3>
      </div>
    </div>
  </section>
</template>
<script>

  export default {
    props: ["whatever"],
    methods: {

      reset() {
        this.$router.push({name: 'Onboard'})
      }

    }

  }

</script>



// WEBPACK FOOTER //
// src/components/onboard/OnboardSuccess.vue